import { createNativeStackNavigator } from "@react-navigation/native-stack";
import Auth from "../screens/Auth/Auth";
import MailAuth from "../screens/Auth/InnerScreens/MailAuth";
import PasswordAuth from "../screens/Auth/InnerScreens/PasswordAuth";
import SetPasswordAuth from "../screens/Auth/InnerScreens/SetPasswordAuth";
import OtpAuth from "../screens/Auth/InnerScreens/OtpAuth";
import AuthSuccess from "../screens/Auth/InnerScreens/AuthSuccess";
import MobileAuth from "../screens/Auth/InnerScreens/MobileAuth";

const AuthStack = createNativeStackNavigator();

export default function AuthNavigationScreens() {
  return (
    <AuthStack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <AuthStack.Screen name="auth" component={Auth} />
      <AuthStack.Screen name="auth-mobile" component={MobileAuth} />
      <AuthStack.Screen name="auth-email" component={MailAuth} />
      <AuthStack.Screen name={"auth-password"} component={PasswordAuth} />
      <AuthStack.Screen name={"auth-setpassword"} component={SetPasswordAuth} />
      <AuthStack.Screen name={"auth-otp"} component={OtpAuth} />
      <AuthStack.Screen
        name={"auth-success"}
        component={AuthSuccess}
        options={{
          headerTitle: "Edit Profile",
        }}
      />
    </AuthStack.Navigator>
  );
}
